import { IConfig } from '@cian/config/shared';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';

import { resolveSearchPromosPageV1 } from './resolveSearchPromosPageV1';
import { resolveSearchPromosPageV2 } from './resolveSearchPromosPageV2';
import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { TSearchPromosResponse } from '../../types/searchResponse';
import { getNewbuildingPromosSeoEnabled } from '../../utils/config';

export async function resolveSearchPromosPage({
  config,
  httpApi,
  logger,
  queryString,
  path,
  jsonQuery,
  subdomain,
}: {
  config: IConfig;
  httpApi: IHttpApi;
  logger: ILogger;
  path?: string;
  queryString?: string;
  jsonQuery?: IJsonQuery;
  subdomain: string;
}): Promise<TSearchPromosResponse> {
  const newbuildingPromosSeoEnabled = getNewbuildingPromosSeoEnabled(config);

  if (newbuildingPromosSeoEnabled) {
    return resolveSearchPromosPageV2({
      httpApi,
      logger,
      path,
      jsonQuery,
      subdomain,
    });
  }

  return resolveSearchPromosPageV1({
    httpApi,
    logger,
    queryString,
    jsonQuery,
    subdomain,
  });
}
